import React, { ReactElement } from 'react';

import styles from './padlock.module.scss';

import padlock from './padlock.svg';

interface PadlockProps {
    className: string;
}

const Padlock: React.FunctionComponent<PadlockProps> = ({ className }: PadlockProps): ReactElement => {
    return (
        <div className={className}>
            <div className={styles.padlock}>
                <img src={padlock} alt={'Security is our priority'} />
                <strong>Security is our priority</strong>
                <p className={styles.paragraph}>We take every precaution to look after your data.</p>
            </div>
        </div>
    );
};

export default Padlock;
